import * as React from 'react';
import { SVGProps } from 'react';
const TrophyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 12H6a3.333 3.333 0 0 1 0-6.667h2M8 12V2.666h16V12M8 12a8 8 0 1 0 16 0m0 0h2a3.334 3.334 0 0 0 0-6.667h-2m-18.667 24h21.333m-13.333-9.786v3.12c0 .733-.627 1.306-1.294 1.613-1.573.72-2.706 2.706-2.706 5.053m9.333-9.786v3.12c0 .733.627 1.306 1.293 1.613 1.574.72 2.707 2.706 2.707 5.053"
    />
  </svg>
);
export default TrophyIcon;
